import { DriveItem, ItemType } from './drive-viewer.models';

export class DriveItemPresentationPolicy {
  fileIcon(filename: string): string {
    const extension = this.extension(filename);
    if (extension === 'pdf') return 'picture_as_pdf';
    if (['doc', 'docx'].includes(extension)) return 'description';
    if (['xls', 'xlsx', 'csv'].includes(extension)) return 'table_chart';
    if (['ppt', 'pptx'].includes(extension)) return 'slideshow';
    if (['txt', 'md', 'log'].includes(extension)) return 'article';
    if (['eml', 'msg', 'email'].includes(extension)) return 'mail';
    if (extension === 'json') return 'data_object';
    if (['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)) return 'folder_zip';
    if (this.isImageExtension(extension)) return 'image';
    if (this.isVideoExtension(extension)) return 'movie';
    return 'insert_drive_file';
  }

  iconClass(filename: string): string {
    const extension = this.extension(filename);
    if (extension === 'pdf') return 'type-pdf';
    if (['doc', 'docx'].includes(extension)) return 'type-docx';
    if (['xls', 'xlsx'].includes(extension)) return 'type-xlsx';
    if (extension === 'csv') return 'type-csv';
    if (['ppt', 'pptx'].includes(extension)) return 'type-pptx';
    if (['txt', 'md', 'log'].includes(extension)) return 'type-txt';
    if (['eml', 'msg', 'email'].includes(extension)) return 'type-email';
    if (extension === 'json') return 'type-json';
    if (['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)) return 'type-zip';
    if (this.isImageExtension(extension)) return 'type-image';
    if (this.isVideoExtension(extension)) return 'type-video';
    return '';
  }

  itemIcon(item: DriveItem): string { return item.type === 'folder' ? 'folder' : this.fileIcon(item.name); }
  itemIconClass(item: DriveItem): string {
    return item.type === 'folder' ? 'type-folder' : this.iconClass(item.name);
  }

  typeByExtension(filename: string): ItemType {
    const extension = this.extension(filename);
    if (this.isImageExtension(extension)) return 'image';
    if (this.isVideoExtension(extension)) return 'video';
    if (['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)) return 'zip';
    if (extension === 'pdf') return 'pdf';
    if (['doc', 'docx'].includes(extension)) return 'doc';
    if (['xlsx', 'xls', 'csv'].includes(extension)) return 'sheet';
    if (['ppt', 'pptx'].includes(extension)) return 'slide';
    if (['txt', 'md', 'log', 'eml', 'msg', 'email', 'json'].includes(extension)) return 'txt';
    return 'other';
  }

  extension(filenameOrItem: string | DriveItem): string {
    const filename = typeof filenameOrItem === 'string' ? filenameOrItem : filenameOrItem.name;
    return filename.split('.').pop()?.toLowerCase() || '';
  }

  viewerUrl(item: DriveItem, rawUrl: string): string {
    if (['pdf', 'txt', 'image', 'video'].includes(item.type)) return rawUrl;
    if (['doc', 'sheet', 'slide'].includes(item.type) && this.extension(item) !== 'csv') {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(rawUrl)}`;
    }
    return rawUrl;
  }

  private isImageExtension(extension: string): boolean {
    return ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'tif', 'tiff'].includes(extension);
  }

  private isVideoExtension(extension: string): boolean {
    return ['mp4', 'webm', 'mov', 'avi', 'mkv'].includes(extension);
  }
}
